const gallery = [
  { src: "https://customer-assets.emergentagent.com/job_seppe-magic/artifacts/zzj18ul6__DSC2090.jpg", alt: "Seppe op het podium" },
  { src: "https://customer-assets.emergentagent.com/job_seppe-magic/artifacts/gfn9cb5f_IMG-20250907-WA0013.jpg", alt: "Close-up magie met publiek" },
  { src: "https://customer-assets.emergentagent.com/job_seppe-magic/artifacts/7y3mz2pd_IMG-20241028-WA0029.jpg", alt: "Eénwieler op een event" },
  { src: "https://customer-assets.emergentagent.com/job_seppe-magic/artifacts/8ce1puw4_IMG_20250909_201253_362.webp", alt: "Kaartmagie buiten" },
];

export default function Gallery() {
  return (
    <section
      id="galerij"
      className="relative py-24 sm:py-32 px-6 lg:px-10"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-gold mb-4">— Galerij</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              Momenten vol <span className="gold-text italic">magie</span>.
            </h2>
          </div>
          <p className="text-[#B5A9C9] max-w-md">
            Een glimp van shows, feesten en straatoptredens — telkens anders, altijd
            met dezelfde energie.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="gallery-grid">
          {gallery.map((g, i) => (
            <div
              key={i}
              className={`group relative overflow-hidden rounded-2xl glass ${
                i === 0 ? "col-span-2 row-span-2 aspect-square" : "aspect-square"
              }`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.src}
                alt={g.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-night/90 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
